import { render, staticRenderFns } from "./answerManage.vue?vue&type=template&id=537ab41e&"
import script from "./answerManage.vue?vue&type=script&lang=js&"
export * from "./answerManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports